import { Component, OnInit } from '@angular/core';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { ScheduleService } from 'src/app/services/schedule.service';
import { UtilitiesService } from '../../services/utilities.service';



@Component({
  selector: 'app-cases',
  templateUrl: './cases.component.html',
})
export class CasesComponent implements OnInit {
  caseList: any[];
  cols: any[];
  schedCaseCols: any[];
  curYear: number;
  // tslint:disable-next-line:variable-name
  private _caseYear: number;
  displayState: any = {
    workingDiv: false,
  };

  filterOptions: any = {
    filterText: '',
    casesNeedSched: '',
    casesOnDate: '',
  };

  schedDateList: any[];
  scheduleDate =  '';
  moveToDate = '';
  schedCaseList: any[];
  selectedCases: any[];
  selectedHearingCases: any[];

  hasRequiredData = true;

  constructor(private messageService: MessageService, private confirmationService: ConfirmationService, private schedService: ScheduleService,
              private utilService: UtilitiesService) { }

  ngOnInit() {
    this.cols = [
      { field: 'caseNum', header: 'Case #' },
      { field: 'applicantName', header: 'Applicant' },
      { field: 'propType', header: 'Property Type'},
      { field: 'city', header: 'City'},
      { field: 'totalValue', header: 'Roll Value'},
      { field: 'valueDifference', header: 'Difference'},
      { field: 'status', header: 'Status' },
    ];
    this.getCaseList();
    this.getHearingDates();

    // [{"applicationId":4910,"caseNum":"08-0211","applicantName":"FIGUEROA,RAUL & CORINA","agencyName":"","propType":"Single Fam Res/Condo/Townhouse","city":"Montecito","totalValue":1803175.00,"valueDifference":631175.00,"status":"Ready for Hearing","subStatus":""},

    this.schedCaseCols = [
      { field: 'caseNum', header: 'Case #' },
      { field: 'applicantName', header: 'Applicant'},
      { field: 'status', header: 'Status'}
    ];
  }

  getCaseList() {
    this.displayState.workingDiv = true;
    this.schedService.getNeedSchedCaseList().subscribe(data => {
      if (data) {
        this.utilService.doAudit(data, 'cases needing sched:');
        this.caseList = data;
      }
      this.displayState.workingDiv = false;
    });
  }

  getHearingDates() {
    const tempDate = new Date();
    const tdy = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate()); // returns today with no time
    const baseDate = new Date();
    baseDate.setDate(baseDate.getDate() - 1); // subtract 1 day
    this.schedService.getHearingDates().subscribe(data => {
      if (data) {
        this.utilService.doAudit(data, 'hearing dates:');
        this.schedDateList = data.filter(t => {
          const tHearDt = new Date(t.hearingDate);
          // return t;   // return ALL dates, not just future ones... used during testing/cleanup
          return tHearDt >= baseDate ? t : null;
        });
        // sort it in chronological order
        this.schedDateList.sort((a, b) => {
          // @ts-ignore
          return new Date(a.hearingDate) - new Date(b.hearingDate);
        });
        const mapped = this.schedDateList.map(item => ({
          ...item,
          // create new field based on the hearingDate (w/o time part) + hearingTime
          hearingDateDesc: `${item.hearingDate.split('T')[0]} ${item.hearingTime}`
        }));
        // this.utilService.doAudit(mapped, 'mapped hearing list:');
        this.schedDateList = mapped;
      }
    });
  }

  getScheduledCases(id: string) {
    this.schedService.getScheduledCases(id).subscribe(data => {
      if (data) {
        this.schedCaseList = data;
      }
      this.selectedHearingCases = [];
    });
  }

  scheduleCases() {
    const myDateId = this.scheduleDate;
    const myList = [];
    this.scheduleDate = ''; // this should disable the Schedule Cases button...
    for (let i = 0; i < this.selectedCases.length; i++) {
      const tCase = {
        applicationId: this.selectedCases[i].applicationId,
        hearingId: myDateId,
        status: this.selectedCases[i].status,
        subStatus: this.selectedCases[i].subStatus,
      };
      myList.push(tCase);
    }
    // console.log(myList);
    this.schedService.scheduleCaseForHearing(myDateId, myList).subscribe(data => {
      if (data === true) {
        this.filterOptions.casesNeedSched = '';
        this.filterOptions.casesOnDate = '';
        this.getCaseList();       // refresh list of cases waiting for scheduling...
        this.selectedCases = [];  // NEEDED?? re-initialize selection of cases...
        this.getScheduledCases(myDateId); // refresh list of cases scheduled for specified Hearing Date
        this.selectedHearingCases = [];
        this.scheduleDate = myDateId;
        // console.log('refreshed sched cases for id: ' + myDateId);
        this.showToast({severity: 'success', summary: '', detail: 'Case(s) scheduled'});
      }
      else {
        alert('Problem scheduling cases!');
        // what else should we do??
      }
    });
  }

  moveCases() {
    const fromDate = this.scheduleDate;
    const toDate = this.moveToDate;
    if (toDate === fromDate) {
      this.showToast({severity: 'error', detail: 'You must specify a different hearing', summary: 'Error'});
      // alert('You can not move cases to the same Hearing Date!');
      return;
    }
    this.confirmationService.confirm({
      message: 'Do you want to move/reschedule these cases?',
      header: 'Move Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let xApplicationId;
        const myCases = [];
        const n = this.selectedHearingCases.length;
        if (n < 1) { return; }
        for (let i = 0; i < n; i++) {
            xApplicationId = this.selectedHearingCases[i].applicationId;
            myCases[i] = xApplicationId;
        }
        this.displayState.workingDiv = true;
        this.schedService.moveCasesToHearing(toDate, myCases).subscribe(data => {
          // console.log('move status: ' + data);
          this.showToast({severity: 'success', detail: 'Case(s) rescheduled.', summary: ''});
          this.selectedHearingCases = [];
          this.getScheduledCases(fromDate);
          this.displayState.workingDiv = false;
        }
        ); },
      reject: () => {
      this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
      }
    });
  }

  selectDate(myDate: any) {
    // console.log('Date selected: ' + this.scheduleDate);
    if (this.scheduleDate) {
      this.getScheduledCases(this.scheduleDate);
    } else {
      this.schedCaseList = [];
      this.selectedHearingCases = [];
    }
  }

  showToast(msg: Message) {
    this.messageService.add(msg);
  }

  clear() {
    this.messageService.clear();
  }


}
